import { httpClient } from "../../../shared/api/httpClient";
import type { PaginatedResponse } from "../../../shared/api/pagination";
import type {
  SellerProductBulkAssignRequest,
  SellerProductBulkAssignResponse,
  SellerProductBulkDeleteRequest,
  SellerProductBulkDeleteResponse,
  SellerProductOverview,
  SellerProductOverviewPage,
  SellerProductPage,
  SellerProductResponse,
} from "../model/types";

export interface SellerProductQuery {
  page: number;
  page_size: number;
  search?: string;
  seller_id?: number;
}

export const fetchSellerProducts = async (
  query: SellerProductQuery,
): Promise<SellerProductPage> => {
  const response = await httpClient.get<
    PaginatedResponse<SellerProductResponse>
  >("/seller-products", { params: query });
  return response.data;
};

export const fetchSellerProductOverview = async (
  query: Omit<SellerProductQuery, "seller_id">,
): Promise<SellerProductOverviewPage> => {
  const response = await httpClient.get<
    PaginatedResponse<SellerProductOverview>
  >("/seller-products/overview", { params: query });
  return response.data;
};

export const bulkAssignSellerProducts = async (
  payload: SellerProductBulkAssignRequest,
): Promise<SellerProductBulkAssignResponse> => {
  const response = await httpClient.post<SellerProductBulkAssignResponse>(
    "/seller-products/bulk",
    payload,
  );
  return response.data;
};

export const bulkDeleteSellerProducts = async (
  payload: SellerProductBulkDeleteRequest,
): Promise<SellerProductBulkDeleteResponse> => {
  const response = await httpClient.post<SellerProductBulkDeleteResponse>(
    "/seller-products/bulk-delete",
    payload,
  );
  return response.data;
};

export const setSellerProductLeader = async (
  sellerProductId: number,
): Promise<{ seller_product_id: number; is_leader: boolean }> => {
  const response = await httpClient.put<{ seller_product_id: number; is_leader: boolean }>(
    `/seller-products/${sellerProductId}/leader`,
  );
  return response.data;
};

export const deleteSellerProduct = async (
  sellerProductId: number,
): Promise<void> => {
  await httpClient.delete(`/seller-products/${sellerProductId}`);
};
